import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { userContext } from "../Context/userContext";
import "../css/gridgallery.css";
import Loading from "./Loading";

const Audio = (props) => {
  const { DateOk } = useContext(userContext);
  const [loading, setLoading] = useState(false);
  const [idList, setIdList] = useState([]);
  const [loadingHeading, setloadingHeading] = useState("Loading...");

  useEffect(() => {
    setLoading(true);
    setloadingHeading("Loading...");
    if (DateOk) {
      axios
        .get(
          "https://lynxlife.club/api/lv1/content/list/" +
            props.contentType +
            "/0/0"
        )
        .then(function (res) {
          if (res.data.items && res.data.items.length > 0) {
            setIdList(res.data.items.map((item) => item.id));
          } else {
            setIdList([]);
          }
          setLoading(false);
        });
    }
  }, [props.contentType, DateOk]);
  //if (DateOk){
  //axios.get("http://localhost:51184/lv1/content/" + Msisdn).then(function (res) {
  //console.log(JSON.stringify(res));
  //if (res.data.bLogin) {
  //setDateOk(res.data.bDateOk);
  //setLoggedin(res.data.bLogin);
  //setMsisdn(res.data.sMsisdn);
  // setoAud(res.data.oAudio);
  //setoWP(res.data.oWallpaper);
  // setoImg(res.data.oImg);
  //  setoZoom(res.data.oZoom);
  //}
  // navigate("../main"); //navigate anyway...checks done on main
  // });
  //}

  return (
    <div className="container">
      <div className="gallery-container">
        <div className="gallery-header">
          {loading ? (
            <Loading heading={loadingHeading} />
          ) : (
            <>
              <h3 className="text-lynx fw-bold">🎵 Music</h3>
              <p className="gallery-subtitle">Tap play to listen</p>
            </>
          )}
        </div>
        {!loading && idList.length === 0 && (
          <div className="gallery-empty">
            <span className="gallery-empty-icon">🐾</span>
            No music yet — check back soon!
          </div>
        )}
        <div className="audio-list">
          {idList.map((id) => (
            <audio key={id} controls>
              {" "}
              <source
                src={`https://lynxlife.club/api/lv1/content/${props.contentType}/${id}`}
                type="audio/mp3"
              />
              Your browser does Not support the audio element.
            </audio>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Audio;
